import { Button, Col, Form, Input, Row, Space } from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined, PhoneOutlined, MailOutlined, KeyOutlined } from '@ant-design/icons';

const ContactInfoStep = ({ Egresado, goNext, goPrev }) => {
    return (
        <Row gutter={[16, 16]} align="middle" justify="center">
            <Col xs={24} sm={20}>
                <Form.Item
                    label="Teléfono Personal"
                    name="telefono_personal"
                    rules={[
                        { required: true, message: 'Ingresa un número de teléfono' },
                        { pattern: /^\d{10}$/, message: 'Debe contener 10 dígitos' }
                    ]}
                >
                    <Input prefix={<PhoneOutlined />} min={10} max={10} placeholder="Ej: 5512345678" />
                </Form.Item>
            </Col>
            <Col xs={24} sm={20}>
                <Form.Item
                    label="Correo Personal"
                    name="correo_personal"
                    rules={[
                        { required: true, message: '¡Por favor ingresa tu correo!' },
                        { type: 'email', message: 'Correo no válido' },
                        { pattern: /^[a-zA-Z0-9_.+-]+@(?!seconalep\.mx$|conalepmex\.edu\.mx$)[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/, message: 'Por favor ingresa un correo que no pertenezca a @seconalep.mx ni @conalepmex.edu.mx' }
                    ]}
                    extra={
                        (Egresado && !Egresado?.correo_institucional) ? (
                            <span style={{ color: 'red' }}>
                                El correo personal será registrado como correo principal para el acceso al sistema de egresados.
                            </span>
                        ) : null
                    }
                >
                    <Input prefix={<MailOutlined />} placeholder="Ej: usuario@email.com" />
                </Form.Item>
            </Col>
            <Col xs={24} sm={20}>
                <Form.Item
                    label="Contraseña"
                    name="password"
                    rules={[
                        { required: true, message: 'Ingresa una contraseña' },
                        { min: 8, max: 20, message: 'Mínimo 8 y máximo 20 caracteres' },
                        {
                            pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
                            message: 'La contraseña debe contener al menos una letra minúscula, una letra mayúscula y un número'
                        }
                    ]}
                >
                    <Input.Password
                        prefix={<KeyOutlined />}
                        placeholder="Ingrese una contraseña segura"
                    />
                </Form.Item>
            </Col>
            <Col xs={24} sm={20}>
                <Form.Item
                    label="Confirmar contraseña"
                    name='confirm_password'
                    dependencies={['password']}
                    rules={[
                        { required: true, message: 'Confirma tu contraseña' },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('password') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('Las contraseñas no coinciden'));
                            },
                        }),
                    ]}
                >
                    <Input.Password prefix={<KeyOutlined />} placeholder="Repite tu contraseña" />
                </Form.Item>
            </Col>
            <Col xs={24} sm={20} align="center">
                <Space justify="space-evenly">
                    <Button icon={<ArrowLeftOutlined />} onClick={goPrev} style={{ marginRight: 8 }}>Atrás</Button>
                    <Button icon={<ArrowRightOutlined />} type="primary" onClick={goNext}>Continuar</Button>
                </Space>
            </Col>
        </Row>
    );
};

export default ContactInfoStep;
